import { render, staticRenderFns } from "./RelatedTicketsSidebar.vue?vue&type=template&id=0d429678&scoped=true&"
import script from "./RelatedTicketsSidebar.vue?vue&type=script&lang=js&"
export * from "./RelatedTicketsSidebar.vue?vue&type=script&lang=js&"
import style0 from "./RelatedTicketsSidebar.vue?vue&type=style&index=0&id=0d429678&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d429678",
  null
  
)

export default component.exports